import React, { Component } from 'react'
import classnames from 'classnames'
import { Icon } from '@driftt/tide-core-legacy'

import './style.styl'

class ConfirmModal extends Component {

  constructor(props) {
    super(props)

    this.state = {
      hidden: true,
      open: false
    }
  }

  componentDidMount() {
    this.handleParentUpdate(this.props)
  }

  static getDerivedStateFromProps(props, state) {
    if(props.open === state.open) return null

    return {
      hidden: !props.open
    }
  }

  componentDidUpdate(props, state) {
    if(props.open !== this.props.open) {
      this.handleParentUpdate(this.props)
    }
  }

  handleParentUpdate({ open }) {
    open ? this.open() : this.close()
  }

  open = () => {
    this.setState({
      hidden: false
    }, this.delayOpen)
  }

  close = () => {
    this.setState({
      open: false
    }, this.delayHidden)
  }

  delayOpen = () => {
    setTimeout(() => {
      this.setState({
        open: true
      })
    }, 0)
  }

  delayHidden = () => {
    setTimeout(() => {
      this.setState({
        hidden: true
      })
    }, 1000)
  }

  render() {
    const { hidden, open } = this.state
    const { children, onClose, className } = this.props
    if (hidden) return null

    return (
      <div className={classnames("tide-action-modal", {"tide-action-modal--open": open})}>
        <div className="tide-action-modal-overlay" />
        <div className="tide-action-modal-close-icon" onClick={onClose}><Icon name="close" size={24} /></div>
        <div className={classnames("tide-action-modal-content", { [className] : !!className })}>
          { children }
        </div>
      </div>
    )
  }
}

export default ConfirmModal


// WEBPACK FOOTER //
// ./src/scripts/components/ConfirmModal/index.js